<template>
  <v-dialog :value="isActive" persistent :width="options.width">
    <v-card :color="options.color">
      <v-card-title>{{ options.title }}</v-card-title>
      <v-card-text v-if="options.text">
        <!-- v-html 属性 -->
        {{ options.text }}
      </v-card-text>
      <v-card-actions>
        <v-spacer />
        <v-btn text @click="close_modal()">确定</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
export default {
  name: "wtk-alert",
  data: () => ({}),
  computed: {
    isActive() {
      return this.$store.getters["message/alert"].isActive;
    },
    options() {
      return this.$store.getters["message/alert"].options;
    },
  },
  methods: {
    close_modal() {
      this.$store.dispatch("message/hide", "alert");
    },
  },
};
</script>